import ActionsForm from '@/shared/mixins/actionsForm'
import { toast, loading } from '@/shared/utils/UIHelper'
import CursosNRRepository from '@/shared/http/repositories/business/coursesNR'
// import aprTemplateEpiRepository from '@/shared/http/repositories/business/aprTemplateEpi'

// import Tools from '@/components/tools/Tools'

export default {
  name: 'addCursosNRApr',
  props: ['aprId', 'revisao'],
  mixins: [ActionsForm],
  components: {},
  data () {
    return {
      Adicionar: true,
      cancelarCursosNR: false,
      dataCursosNR: [],
      datanewCursosNR: {},
      dataFiltroCursosNR: [],
      buscaCursosNR: '',
      CursosNRAguardandoEnvio: []
    }
  },

  watch: {
    buscaCursosNR (newvalue, oldvalue) {
      if (newvalue.trim() !== '') {
        this.BuscaCursosNRAdd(newvalue)
      } else {
        this.dataFiltroCursosNR = this.dataCursosNR
      }
    }
  },

  mounted () {
  },
  methods: {
    AdicionarFerramentas (id) {
      let novaFerramenta = {descricao: id.descricao, statusAprovacaoDescricao: 'AG. ENVIO', statusAprovacao: null, dateCricaoFormatada: null, dateCricao: null, cursosNRId: id.id, tipoMudanca: 'INCLUSÃO AG. ENVIO', AgEnvio: true}
      this.CursosNRAguardandoEnvio.push(novaFerramenta)
      this.Adicionar = !this.Adicionar
      var div = document.getElementById(id.id)
      // Verifica se a classe 'clicked' já está presente na div
      var isClicked = div.classList.contains('clicked')
      // Se já estiver clicada, remove a classe, caso contrário, adiciona
      if (isClicked) {
        div.classList.remove('clicked')
        this.CursosNRAguardandoEnvio = this.CursosNRAguardandoEnvio.filter(epi => epi.cursosNRId !== id.id)
      } else {
        div.classList.add('clicked')
      }
    },
    identificarElementosClicados () {
      var elementosClicados = []
      this.dataCursosNR.forEach(function (elemento) {
        var elementoHTML = document.getElementById(elemento.id)
        if (elementoHTML && elementoHTML.classList.contains('clicked')) {
          elementosClicados.push(elementoHTML.id)
        }
      })
      if (elementosClicados.length > 0) {
        this.addEPI(elementosClicados)
      } else {
        toast.warning('Adicione pelo menos um item')
      }
    },
    cancel () {
      this.cancelarCursosNR = !this.cancelarCursosNR
      this.$emit('cancelarCursosNR', this.cancelarCursosNR)
    },
    addEPI (ids) {
      console.log(ids)
      this.datanewCursosNR = {CursosNR: ids, APRId: this.aprId}
      this.$emit('salvarCursosNR', this.datanewCursosNR)
      this.$emit('AdicionarTableCursosNR', this.CursosNRAguardandoEnvio)
    },
    onLoad () {
      loading.push()
      CursosNRRepository.GetCursosNR(this.aprId, this.revisao)
        .then((Response) => {
          loading.pop()
          this.dataCursosNR = Response.data.data
          this.dataFiltroCursosNR = Response.data.data
        }).catch(Error => {
          loading.pop()
          toast.error('Erro ao carregar as informações')
        })
    },
    BuscaCursosNRAdd (value) {
      this.dataFiltroCursosNR = this.dataCursosNR.filter((Element) => Element.descricao.toUpperCase().indexOf(value.toUpperCase()) > -1)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/apr/templateApr/components/addCourseApr/addCourseApr.js